import { Link } from 'react-router-dom';

export function Button({
  children,
  to,
  href,
  variant = 'primary',
  className = '',
  type = 'button',
  onClick,
  disabled = false
}) {
  const classes = `button button--${variant} ${disabled ? 'is-disabled' : ''} ${className}`.trim();

  if (to) {
    return (
      <Link className={classes} to={to} onClick={onClick} aria-disabled={disabled}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a
        className={classes}
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        aria-disabled={disabled}
      >
        {children}
      </a>
    );
  }

  return (
    <button className={classes} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
